import * as React from 'react'
import { useLoaderData } from 'react-router-dom'

import { Content } from 'sdk/components'
import { Divider } from 'sdk'
import { NewsSection } from './components/news-section/NewsSection'
import { AccelerationSection } from './sections/acceleration/AccelerationSection'
import { TechBenefitsSection } from './sections/tech-benefits/TechBenefitsSection'
import { SoundcoreSection } from './sections/soundcore/SoundcoreSection'
import { SoundscapeSection } from './sections/soundscape/SoundscapeSection'
import { PartnerProgramFeatureSection } from './sections/partner-program/PartnerProgramFeatureSection'
import { BottomHeroSection } from './sections/bottom-hero/BottomHeroSection'
import { NewsfeedEntry } from 'core/interfaces'

import { Hero } from './sections/hero/Hero'

export const HomePage: React.FC = () => {
  const newsfeed: NewsfeedEntry[] = useLoaderData() as NewsfeedEntry[]

  return (
    <>
      <Hero />
      <Content gap={150}>
        <NewsSection items={newsfeed} />
        <AccelerationSection />
        <Divider />
        <SoundcoreSection />
        <SoundscapeSection />
        <Divider />
        <PartnerProgramFeatureSection />
        <TechBenefitsSection />
      </Content>
      <BottomHeroSection
        title={
          <>
            Complete Knowledge Hub <br /> for Developers
          </>
        }
        description='Access explainers, documentation, guides, examples, and support for end-to-end development and deployment'
        buttonHref='/resources'
      />
    </>
  )
}
